const initSaltyProductBanners = (root) => {
  const sections = root.matches?.('.salty-product-top') ? [root] : root.querySelectorAll('.salty-product-top');
  sections.forEach((section) => {
    if (section.dataset.bannerReady === 'true') return;
    section.dataset.bannerReady = 'true';

    const track = section.querySelector('[data-salty-banner-track]');
    const dotsContainer = section.querySelector('[data-salty-banner-dots]');
    const banners = [...(track?.querySelectorAll('.salty-product-top__slide') || [])];
    if (!track || !dotsContainer || banners.length < 2) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const pageSize = () => window.matchMedia('(max-width: 749px)').matches ? 4 : 2;
    const pageCount = () => Math.max(1, Math.ceil(banners.length / pageSize()));
    let current = 0;
    let visible = true;
    let dots = [];

    const leftFor = (index) => banners[index * pageSize()]?.offsetLeft - banners[0].offsetLeft || 0;
    const show = (index, smooth = true) => {
      current = (index + pageCount()) % pageCount();
      dots.forEach((dot, dotIndex) => dot.setAttribute('aria-pressed', String(dotIndex === current)));
      track.scrollTo({ left: leftFor(current), behavior: smooth && !reducedMotion.matches ? 'smooth' : 'instant' });
    };

    const buildDots = () => {
      current = Math.min(current, pageCount() - 1);
      dotsContainer.replaceChildren();
      dots = Array.from({ length: pageCount() }, (_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', `バナー ${index + 1} を表示`);
        dot.addEventListener('click', () => show(index));
        dotsContainer.append(dot);
        return dot;
      });
      dotsContainer.hidden = pageCount() < 2;
      show(current, false);
    };

    track.addEventListener('scroll', () => {
      let nearest = 0;
      for (let index = 1; index < pageCount(); index += 1) {
        if (Math.abs(track.scrollLeft - leftFor(index)) < Math.abs(track.scrollLeft - leftFor(nearest))) nearest = index;
      }
      current = nearest;
      dots.forEach((dot, dotIndex) => dot.setAttribute('aria-pressed', String(dotIndex === nearest)));
    }, { passive: true });

    window.addEventListener('resize', buildDots);
    buildDots();

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; }, { threshold: 0.2 });
      observer.observe(section);
    }

    const timer = window.setInterval(() => {
      if (!section.isConnected) {
        window.clearInterval(timer);
        return;
      }
      if (pageCount() > 1 && visible && !document.hidden && !reducedMotion.matches && !section.matches(':hover, :focus-within')) show(current + 1);
    }, 5000);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initSaltyProductBanners(document), { once: true });
} else {
  initSaltyProductBanners(document);
}

document.addEventListener('shopify:section:load', (event) => initSaltyProductBanners(event.target));
